import { render, staticRenderFns } from "./WideOutlinedButton.vue?vue&type=template&id=ddde3cc0"
import script from "./WideOutlinedButton.vue?vue&type=script&lang=js"
export * from "./WideOutlinedButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports